import { Contexto } from 'src/app/asistente-en-linea/models/contexto';
import { DatosChat } from '../../../../models/DatosChat';

export class EnviarMensajeRequest {

    public mensaje: string;

    public idAsistente: number;
    public participantID: string;
    public agente: string;
    public idNodo: string;   
    public chat: DatosChat;
}